import { Outlet } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import EmployeesComponent from 'modules/locations/pages/Locations/Employees'

const AuthorizedEmployeesPage = () => {
  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <EmployeesComponent contractVersions={contractVersions} loading={loading}>
      <Outlet />
    </EmployeesComponent>
  )
}

export default AuthorizedEmployeesPage
